import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, filter, size, map, includes } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import TableRow from "@material-ui/core/TableRow";

import TableCellStyled from "../Common/TableCellStyled";

import { formatDate } from "../../utils/date";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  tableRowHover: {
    "&:hover": {
      backgroundColor: `${colors.lightGreenBg} !important`,
    },
  },
};

const ProfileVerificationVehicleRow = (props) => {
  const { classes, item, index, language } = props;

  const dataCell = (data, text54 = false) => {
    return (
      <TableCellStyled
        className={clsx({
          "text-54": text54,
        })}
        style={{
          padding: "0px 18px !important",
        }}
      >
        {data}
      </TableCellStyled>
    );
  };

  let verifications = {
    fuel:
      size(
        filter(
          get(item, ["attributes"]),
          (attr) => includes([79], attr.id) && attr.value
        )
      ) > 0,
    odometer:
      size(
        filter(
          get(item, ["attributes"]),
          (attr) => includes([83], attr.id) && attr.value
        )
      ) > 0,
    temperature:
      size(
        filter(
          get(item, ["attributes"]),
          (attr) =>
            includes([115, 113, 80, 118, 119, 116, 112, 117, 114], attr.id) &&
            attr.value
        )
      ) > 0,
    seal:
      size(
        filter(
          get(item, ["attributes"]),
          (attr) => includes([81], attr.id) && attr.value
        )
      ) > 0,
  };

  return (
    <TableRow
      style={{
        backgroundColor: index % 2 === 1 ? colors.tableDarkBg : colors.white,
      }}
      hover={true}
      classes={{ hover: classes.tableRowHover }}
    >
      {dataCell(get(item, ["type", `name_${language}`]), true)}
      {dataCell(formatDate(get(item, ["created_on"])), true)}
      {dataCell(
        get(item, ["zone"])
          ? `${get(item, ["zone", "name"])} - ${get(item, [
              "zone",
              "site",
              "name",
            ])}`
          : I18n.get("profiles_remote"),
        true
      )}
      {dataCell(
        get(item, ["device", "name"])
          ? get(item, ["device", "name"])
          : I18n.get("profiles_online"),
        true
      )}
      {dataCell(
        <Grid container alignItems="center">
          <Grid
            item
            className="text-54"
            style={{ minWidth: "17px", textAlign: "right" }}
          >
            {size(filter(verifications, (v) => v))}
          </Grid>
          <Grid
            item
            className="text-87 bold-500"
            style={{ marginLeft: "5px", marginRight: "15px" }}
          >
            {I18n.get("profiles_pass")}
          </Grid>
          <Grid
            item
            className="text-54"
            style={{ minWidth: "17px", textAlign: "right" }}
          >
            0
          </Grid>
          <Grid
            item
            className="text-87 bold-500"
            style={{ marginLeft: "5px", marginRight: "15px" }}
          >
            {I18n.get("profiles_fail")}
          </Grid>
          <Grid
            item
            className="text-54"
            style={{ minWidth: "17px", textAlign: "right" }}
          >
            0
          </Grid>
          <Grid item className="text-87 bold-500" style={{ marginLeft: "5px" }}>
            {I18n.get("profiles_other")}
          </Grid>
          <Grid
            item
            style={{
              borderRight: `1px solid ${colors.veryLighPink}`,
              paddingLeft: "10px",
              marginRight: "10px",
              width: "2px",
              height: "30px",
            }}
          />
          {map(verifications, (v, k) => (
            <Grid item key={k}>
              {v && (
                <img
                  src={images[`${k}Icon`]}
                  alt="verifIcon"
                  style={{ marginRight: "5px" }}
                />
              )}
            </Grid>
          ))}
        </Grid>
      )}
      {dataCell("-", true)}
      {dataCell("-", true)}
      {dataCell("-", true)}
      {dataCell(get(item, ["created_by"]) || "-", true)}
    </TableRow>
  );
};

export default withStyles(styles)(ProfileVerificationVehicleRow);
